import {AbstractControl} from "@angular/forms";
import {throwError} from "rxjs";
import {HttpEventService} from "src/app/services/http/http-event.service";
import {HttpHeaders} from "@angular/common/http";

export const handleCommonErrors = function (
	err: any,
	httpEventService: HttpEventService
) {
	if (err.status === 403) {
		httpEventService.onAccessDenied.emit();
	} else if (err.status === 503) {
		httpEventService.onServiceUnavailableError.emit();
	} else if (err.status === 401) {
		httpEventService.onTokenExpiry.emit();
	} else if (err.status === 504) {
		if (err.message.search("504 Gateway Time-out") !== -1) {
			httpEventService.onServiceUnavailableError.emit();
		}
	} else if (err.status === 500) {
		if (
			err.error.message.search("connection timed out:") !== -1 ||
			err.error.message.search("Connection refused:") !== -1 ||
			err.error.message === "placement-optimizer-service"
		) {
			httpEventService.onServiceUnavailableError.emit();
		} else {
			httpEventService.onServerError.emit(err);
		}
	} else {
		httpEventService.onServerError.emit(err);
	}
};

export const handleError = function (
	operation: String,
	url: string,
	httpEventService: HttpEventService,
	filename?: string
) {
	return (err: any) => {
		const errMsg = `error in ${operation}() retrieving ${url}`;
		let entity;
		let errors: any[] = [];

		if (err.status === 500) {
			if (
				err.error.message ===
				"InterfaceCode already exists for the Credit Granter tenant." ||
				err.error.message === "DUPLICATE_INTERFACECODE"
			) {
				entity = "Interface Code";
				httpEventService.onInterfaceCodeExistError.emit(entity);
			} else if (
				err.error.message === "Client short name already exist"
			) {
				entity = "Short name";
				httpEventService.onNameExistError.emit(entity);
			} else if (err.error.message === "Tenant already mapped") {
				httpEventService.onTenantMappingExistError.emit();
			} else if (err.error.message === "Tenant name already mapped") {
				httpEventService.onTenantNameError.emit();
			} else if (err.error.message === "INACTIVE_CLIENT_RELATIONSHIP") {
				httpEventService.onClientRelationshipInactiveError.emit();
			} else if (err.error.message === "INVALID_CLIENT_RELATIONSHIP") {
				httpEventService.onClientRelationshipInvalidError.emit();
			} else if (err.error.message === "INVALID_CLIENT") {
				httpEventService.onInvalidClientError.emit();
			} else if (
				err.error.message === "client-management-service" ||
				err.error.message === "fileops-service" ||
				err.error.message === "placement-optimizer-service"
			) {
				httpEventService.onServiceUnavailableError.emit();
			} else if (err.error.message === "CLIENT_RELATIONSHIP_NOT_ACTIVE") {
				httpEventService.onInterfaceCreationError.emit();
			} else if (err.error.message === "401 Unauthorized") {
				httpEventService.onUnauthorizedAccessToken.emit();
			} else if (
				err.error.message ===
				"Classification can not be set for the partner relationship."
			) {
				httpEventService.onClassificationError.emit();
			} else if (
				err.error.message.search("connection timed out:") !== -1
			) {
				httpEventService.onServiceUnavailableError.emit();
			} else if (err.error.message.search("Connection refused:") !== -1) {
				httpEventService.onServiceUnavailableError.emit();
			} else if (err.error.message === "INVALID_DMP_ACCESS_TOKEN") {
				httpEventService.onUnauthorizedAccessToken.emit();
			} else if (err.error.message === "DUPLICATE_BILLINGRATETIER") {
				httpEventService.onDuplicateRateTier.emit();
			} else if (err.error.message === "DUPLICATE_BILLINGRATE") {
				httpEventService.onDuplicateRateCode.emit();
			} else if (
				err.error.message.search(
					"Data Integrity or Constraint Violation"
				) !== -1 &&
				operation === "InterfaceService.createInterface"
			) {
				httpEventService.onInterfaceCodeExistInSameRelationshipError.emit();
			} else if (
				err.error.message === "TRANSACTION_CODE_ALREADY_EXISTS"
			) {
				httpEventService.onTransactionAlreadyExistError.emit();
			} else if (err.error.message === "FILEDATA_ALREADY_EXISTS") {
				httpEventService.onFileDataAlreadyExistError.emit();
			} else {
				httpEventService.onServerError.emit(err);
			}
		} else if (err.status === 406) {
			if (operation === "FileManagementService.retrieveFile") {
				httpEventService.onFileDownloadError.emit(filename);
			}
		} else if (err.status === 503) {
			httpEventService.onServiceUnavailableError.emit();
		} else if (err.status === 417) {
			if (
				err.error.message.includes("VALIDATION_FAILED") ||
				err.error.message === "VALIDATION_FAILED"
			) {
				errors = err.error.fieldErrors;
				const fieldErrorsArray = Object.values(errors);
				fieldErrorsArray.forEach((element) => {
					if (
						element.message ===
						"File name contains one or more disallowed characters"
					) {
						httpEventService.onFileNameInvalidError.emit(filename);
					} else if (
						element.message ===
						"MULTIPLE_FILES_NOT_ALLOWED_IN_COMPRESSED"
					) {
						httpEventService.onMultipleFilesNotAllowedError.emit(
							filename
						);
					} else if (
						element.message ===
						"DIRECTORY_NOT_ALLOWED_IN_COMPRESSED"
					) {
						httpEventService.onDirectoriesNotAllowedError.emit(
							filename
						);
					} else if (
						element.message === "BAD_FILENAME_IN_COMPRESSED"
					) {
						httpEventService.onFileNameInvalidCompressedFileError.emit(
							filename
						);
					} else if (element.message === "INVALID_COMPRESSED_FILE") {
						httpEventService.onInvalidCompressedFileError.emit(
							filename
						);
					} else if (
						element.message === "ZERO_BYTE_COMPRESSED_FILE"
					) {
						httpEventService.onZeroByteCompressedFileError.emit(
							filename
						);
					} else if (element.message === "INVALID_BATCH_ID") {
						httpEventService.onInvalidFileName.emit(filename);
					} else if (
						element.code === "INACTIVE_CLIENT_RELATIONSHIP"
					) {
						httpEventService.onClientRelationshipInactiveError.emit(
							filename
						);
					} else if (element.message === "DUPLICATE_BATCH_ID") {
						httpEventService.onDuplicateBatchId.emit();
					} else if (
						element.message
							.toLowerCase()
							.search("duplicate filename found") !== -1
					) {
						httpEventService.onFileAlreadyRegisteredError.emit(
							element.message
						);
					} else if (
						element.message.search("Duplicate File Content") !== -1
					) {
						httpEventService.onDuplicateFileContentError.emit(
							element.message
						);
					} else if (
						element.code ===
						"FORMAT_B_FILE_SIZE_RECORD_LENGTH_ERROR"
					) {
						httpEventService.onFormatBFileSizeError.emit(
							element.message
						);
					} else if (element.code === "INACTIVE_SENDER") {
						httpEventService.onInactiveSenderError.emit(filename);
					} else if (element.code === "INACTIVE_RECIPIENT") {
						httpEventService.onInactiveRecipientError.emit(
							filename
						);
					} else if (
						element.message.search("File not found:") !== -1
					) {
						httpEventService.onFileNotFoundError.emit(filename);
					} else if (
						element.message.search(
							"You are not authorized to upload Passthrough files"
						) !== -1
					) {
						httpEventService.onPassthroughFilesDisabled.emit(
							sessionStorage["partnerClientName"]
						);
					} else if (element.code === "INVALID_CLIENT_RELATIONSHIP") {
						httpEventService.onClientRelationshipInvalidError.emit(
							filename
						);
					}
				});
			} else if (err.error.message === "DUPLICATE_REGISTRATION") {
				if (operation === "UploadFilesService.reprocessFailedFile") {
					httpEventService.onReprocessedDuplicateFileContentError.emit(
						filename
					);
				} else {
					httpEventService.onDuplicateFileContentError.emit(filename);
				}
			} else if (
				err.error.message === "DMP_TENANT_PROTOTYPE_NOT_DEFINED"
			) {
				httpEventService.onDPMProtoTypeNotDefinedError.emit();
			} else if (err.error.message === "DUPLICATE_FILE_CONTENT") {
				httpEventService.onDuplicateFileContentError.emit(filename);
			} else if (err.error.message === "ERROR_WHILE_STAGING") {
				httpEventService.onErrorWhileStagingError.emit(filename);
			} else if (
				err.error.message === "FILE_NAME_INVALID" ||
				err.error.message === "NULL_FILE_NAME"
			) {
				httpEventService.onFileNameInvalidError.emit(filename);
			} else if (err.error.message === "FILE_ID_NOT_FOUND") {
				httpEventService.onImportedFileIdNotFoundError.emit(filename);
			} else if (err.error.message === "INACTIVE_DOCUMENT_TYPE") {
				httpEventService.onDocumentTypeInactiveError.emit(filename);
			} else if (err.error.message === "INVALID_DOCUMENT_TYPE") {
				httpEventService.onDocumentTypeInvalidError.emit(filename);
			} else if (err.error.message === "INACTIVE_RECIPIENT") {
				httpEventService.onInactiveRecipientError.emit(filename);
			} else if (err.error.message === "IOEXCEPTION_STAGING") {
				httpEventService.onFileUploadError.emit(filename);
			} else if (err.error.message === "ZERO_BYTE_FILE_ERROR") {
				httpEventService.onZeroByteFileError.emit(filename);
			} else if (err.error.message === "INVALID_RECIPIENT_SHORT_NAME") {
				httpEventService.onInvalidRecipientShortNameError.emit(
					filename
				);
			} else if (err.error.message === "INACTIVE_SENDER") {
				httpEventService.onInactiveSenderError.emit(filename);
			} else if (err.error.message === "EXPORTED_FILE_NOT_FOUND") {
				httpEventService.onExportedFileNotFoundError.emit(filename);
			} else if (
				err.error.message === "INVALID_CLIENT" ||
				err.error.message === "Invalid access token" ||
				err.error.message === "clientShortName cannot be empty"
			) {
				httpEventService.onInvalidClientError.emit();
			} else if (operation === "FileManagementService.retrieveFile") {
				httpEventService.onFileDownloadError.emit(filename);
			}  else if (err.error.message === "LXNX_PROPS_INVALID") {
				httpEventService.onLxnxPropsInvalidError.emit();
			} else if (err.error.message === "LXNX_PROPS_MISSING_VALUES") {
				httpEventService.onLxnxPropsMissingError.emit();
			} else if (err.error.message === "SUPPORTED_SCHEMA_INVALID") {
				httpEventService.onSupportedSchemaInvalidError.emit();
			} else if (
				err.error.message === "SUPPORTED_SCHEMA_MISSING_VALUES"
			) {
				httpEventService.onSupportedSchemaMissingError.emit();
			} else if (err.error.message === "DUPLICATE_TENANT_NAME") {
				httpEventService.onDuplicateTenantNameError.emit();
			}  else if (err.error.message === "DATA_SOURCE_PROPS_INVALID") {
				httpEventService.onInvalidDataSourceJobPropsError.emit();
			} else if (
				err.error.message === "DATA_SOURCE_PROPS_MISSING_VALUES"
			) {
				httpEventService.onMissingDataSourcePropsError.emit();
			} else if (err.error.message === "PO_CLIENT_CONFIG_MISSING") {
				httpEventService.onPOClientConfigMissing.emit();
			} else if (
				err.error.message === "PO_CLIENT_CONFIG_VALUES_MISSING"
			) {
				httpEventService.onPOClientConfigValueMissing.emit();
			} else if (err.error.message === "PO_DATA_SOURCE_PROPS_INVALID") {
				httpEventService.onInvalidPODataSourcePropsError.emit();
			} else if (
				err.error.message === "PO_DATA_SOURCE_PROPS_MISSING_VALUES"
			) {
				httpEventService.onMissingPODataSourcePropsError.emit();
			}  else if (
				err.error.message === "IMPORT_FILE_NOT_IN_PENDING_STATUS"
			) {
				httpEventService.onImportFileNotInPendingStatus.emit(filename);
			} else if (err.error.message === "SYSTEM_ERROR") {
				httpEventService.onErrorWhileStagingError.emit(filename);
			} else if (
				err.error.message === "DOWNLOAD_RECORD_DELIMITER_MISSING"
			) {
				httpEventService.onMissingDownloadRecordDelimiter.emit();
			} else if (
				err.error.message === "DOWNLOAD_RECORD_DELIMITER_INVALID"
			) {
				httpEventService.onInvalidDownloadRecordDelimiter.emit();
			} else if (err.error.message === "FILE_FORMAT_INVALID") {
				httpEventService.onFileFormatInvalid.emit();
			} else if (err.error.message === "FILE_FORMAT_MISSING") {
				httpEventService.onFileFormatMissing.emit();
			} else if (
				err.error.message.search("Entered RMS BankID is not unique") !==
				-1
			) {
				httpEventService.onDuplicateLegacyRMSBankId.emit();
			} else if (
				err.error.message === "MAINTENANCE_RECORD_LENGTH_MISSING"
			) {
				httpEventService.onMaintenanceRecordLengthMissing.emit();
			} else if (
				err.error.message === "PLACEMENT_RECORD_LENGTH_MISSING"
			) {
				httpEventService.onPlacementRecordLengthMissing.emit();
			} else if (err.error.message === "LEGACY_RMS_BANK_ID_INVALID") {
				httpEventService.onInvalidLegacyRMSBankId.emit();
			} else if (err.error.message === "LEGACY_RMS_BANK_ID_MISSING") {
				httpEventService.onMissingLegacyRMSBankId.emit();
			} else if (err.error.message === "XML_SCHEMA_VERSION_MISSING") {
				httpEventService.onXMLSchemaVersionMissing.emit();
			} else if (
				err.error.message.search("Client short name already exists") !==
				-1
			) {
				entity = "Short name";
				httpEventService.onNameExistError.emit(entity);
			} else if (
				err.error.message === "STORAGE_PROPS_BUCKET_NAME_EMPTY"
			) {
				httpEventService.onStoragePropsBucketNameEmpty.emit();
			} else if (
				err.error.message === "STORAGE_PROPS_OBJECT_KEY_PREFIX_EMPTY"
			) {
				httpEventService.onStoragePropsObjectKeyPrefixEmpty.emit();
			} else if (err.error.message === "STORAGE_PROPS_REGION_EMPTY") {
				httpEventService.onStoragePropsRegionEmpty.emit();
			} else if (
				err.error.message === "STORAGE_PROPS_S3ACCESS_KEY_EMPTY"
			) {
				httpEventService.onStoragePropsS3AccessKeyEmpty.emit();
			} else if (
				err.error.message === "STORAGE_PROPS_S3SECRET_KEY_EMPTY"
			) {
				httpEventService.onStoragePropsS3SecretKeyEmpty.emit();
			} else if (
				err.error.message === "STORAGE_PROPS_S3SERVICE_URL_EMPTY"
			) {
				httpEventService.onStoragePropsS3ServiceURLEmpty.emit();
			} else if (err.error.message === "CONCATENATION_SCHEDULE_INVALID") {
				httpEventService.onConcatenationScheduleInvalid.emit();
			} else if (
				err.error.message ===
				"CONCATENATION_FILENAME_UNMATCHED_BRACES_FBFIN"
			) {
				httpEventService.onConcatenatedFileNameUnmatchedBracesFBFIN.emit();
			} else if (
				err.error.message ===
				"CONCATENATION_FILENAME_UNMATCHED_BRACES_FBMNT"
			) {
				httpEventService.onConcatenatedFileNameUnmatchedBracesFBMNT.emit();
			} else if (
				err.error.message ===
				"CONCATENATION_FILENAME_UNMATCHED_BRACES_FBAUD"
			) {
				httpEventService.onConcatenatedFileNameUnmatchedBracesFBAUD.emit();
			} else if (
				err.error.message === "CONCATENATION_FILENAMES_MUST_BE_UNIQUE"
			) {
				httpEventService.onConcatenationFileNamesNotUnique.emit();
			} else if (
				err.error.message === "DATA_RETENTION_PERIOD_DAYS_INVALID"
			) {
				httpEventService.onDataRetentionPeriodInvalid.emit();
			} else if (
				err.error.message === "DATA_RETENTION_PERIOD_DAYS_MISSING"
			) {
				httpEventService.onDataRetentionPeriodMissing.emit();
			} else if (
				err.error.message.search("IPV4_ADDRESS_RANGE_INVALID") !== -1
			) {
				httpEventService.onInvalidIPAddressRange.emit(
					err.error.message
				);
			}
		} else if (err.status === 400) {
			if (err.error.message.search("MimeType mismatch for file") !== -1) {
				httpEventService.onMimeTypeMismatch.emit(filename);
			} else {
				httpEventService.onKafkaConnectorError.emit(err.error.message);
			}
		} else if (err.status === 401) {
			httpEventService.onTokenExpiry.emit();
		} else if (err.status === 403) {
			httpEventService.onAccessDenied.emit();
		} else if (err.status === 504) {
			if (err.message.search("504 Gateway Time-out") !== -1) {
				httpEventService.onServiceUnavailableError.emit();
			}
		} else if (err.status === 409) {
			httpEventService.onKafkaConnectorError.emit(err.error.message);
		} else {
			httpEventService.onServerError.emit(err);
		}
		return throwError(errMsg);
	};
};

export const ValidateEmptySpace = function (formControl: AbstractControl) {
	return formControl &&
	formControl.value &&
	formControl.value.toString().trim().length > 0
		? null
		: {
			validateEmptySpace: {
				valid: false,
			},
		};
};

export const httpOptions = (): object => ({
	headers: new HttpHeaders({
		"Content-Type": "application/vnd.crsoftware.cnrhub.clientmanagement.v1+json",
		Accept: "application/vnd.crsoftware.cnrhub.clientmanagement.v1+json",
	}),
});

export const httpOptionsForOrganizationManagement = (isV2: boolean): object => ({
	headers: new HttpHeaders({
		"Content-Type": "application/vnd.com.crsoftware.cnrhub.clientmanagement.internal.v2_0+json",
		Accept: isV2 ? "application/vnd.com.crsoftware.cnrhub.clientmanagement.internal.v2_0+json" : "application/vnd.crsoftware.cnrhub.clientmanagement.v1+json",
	})
});

const addOrgToHeaders = (httpHeaders: HttpHeaders): object => ({
	headers: sessionStorage.getItem("org")
		? httpHeaders.append('org', JSON.parse(<string>sessionStorage.getItem("org"))["clientShortName"])
		: httpHeaders
})
const addOrg_ProgressToHeaders = (httpHeaders: HttpHeaders): object => ({
	headers: sessionStorage.getItem("org")
		? httpHeaders.append('org', JSON.parse(<string>sessionStorage.getItem("org"))["clientShortName"])
		: httpHeaders,
	reportProgress: true,
	observe: "events"
})
export const httpOptionsForFileManagement = (): object => addOrgToHeaders(new HttpHeaders({
	"Content-Type":
		"application/vnd.com.crsoftware.cnrhub.fileops.internal.v1_0+json",
	Accept: "application/vnd.com.crsoftware.cnrhub.fileops.internal.v1_0+json",
}));

export const httpOptionsForImportedFiles = (): object => addOrgToHeaders(new HttpHeaders({
	"Content-Type": "application/vnd.com.crsoftware.cnrhub.public.v3_0+json",
	Accept: "application/vnd.com.crsoftware.cnrhub.public.v3_0+json",
}));

export const httpOptionsForFileManagementFileError = (): object => addOrgToHeaders(new HttpHeaders({
	"Content-Type": "application/vnd.com.crsoftware.cnrhub.fileops.internal.v2_0+json",
	Accept: "application/vnd.com.crsoftware.cnrhub.fileops.internal.v2_0+json",
}));

export const httpOptionsForFileUpload = (): object => addOrg_ProgressToHeaders(new HttpHeaders({
	Accept: "application/vnd.com.crsoftware.cnrhub.public.v3_0+json",
	observe: "events"
}));

export const httpOptionsForFileManagementFailedFiles = (): object => addOrgToHeaders(new HttpHeaders({
	"Content-Type": "application/vnd.com.crsoftware.cnrhub.fileops.internal.v2_0+json",
	Accept: "application/vnd.com.crsoftware.cnrhub.fileops.internal.v2_0+json",
}));

export const createHttpOptionsForPlacementsOptimizer = (): object => addOrgToHeaders(new HttpHeaders({
	Accept: "application/vnd.com.fico.cnrhub.poservice.internal.v1_0+json",
	"Content-Type": "application/vnd.com.fico.cnrhub.poservice.internal.v1_0+json",
}));
export const httpOptionsForPlacementsOptimizer = (): object => addOrgToHeaders(new HttpHeaders({
	Accept: "application/vnd.com.fico.cnrhub.poservice.internal.v1_0+json",
	"Content-Type": "application/vnd.com.fico.cnrhub.poservice.internal.v1_0+json",
}));

export const httpOptionsForKafkaConnectorsManagement = (): object => ({
	headers: new HttpHeaders({
		"Content-Type": "application/vnd.com.crsoftware.cnrhub.kafkaconnectmanager.internal.v1_0+json",
		Accept: "application/vnd.com.crsoftware.cnrhub.kafkaconnectmanager.internal.v1_0+json",
	}),
});

export const httpOptionsForDataBaseOperationsManager = (): object => ({
	headers: new HttpHeaders({
		"Content-Type": "application/vnd.com.crsoftware.cnrhub.operationsmanager.internal.v1_0+json",
		Accept: "application/vnd.com.crsoftware.cnrhub.operationsmanager.internal.v1_0+json",
	}),
});

export const httpOptionsForReprocessFiles = (): object => {
	const isInternalUser: boolean = sessionStorage.getItem("isInternalUser") === 'true';
	return isInternalUser ? addOrgToHeaders(new HttpHeaders({
		"Content-Type": "application/vnd.com.crsoftware.cnrhub.fileops.internal.v2_0+json",
		Accept: "application/vnd.com.crsoftware.cnrhub.fileops.internal.v2_0+json",
	})) : new HttpHeaders({});
};

export const httpOptionsForFileOpsPublicApi = (): object => addOrgToHeaders(new HttpHeaders({
	"Content-Type": "application/vnd.com.crsoftware.cnrhub.public.v3_0+json",
	Accept: "application/vnd.com.crsoftware.cnrhub.public.v3_0+json",
}));

export const httpOptionsForPublicApi = (): object => addOrgToHeaders(new HttpHeaders({
	"Content-Type": "application/vnd.com.crsoftware.cnrhub.public.v3_0+json",
	Accept: "application/vnd.com.crsoftware.cnrhub.public.v3_0+json",
}));

export const httpOptionsForTenantReProvision = (): object => ({
	headers: new HttpHeaders({
		"Content-Type": "application/vnd.com.crsoftware.cnrhub.clientmanagement.internal.v1_0+json",
		Accept: "application/vnd.com.crsoftware.cnrhub.clientmanagement.internal.v1_0+json",
	}),
});

export function isDefined<T>(value: T): boolean {
	return typeof value !== "undefined" && value !== null;
}
